<div class="s-card {{ rootClasses }}" [style]="rootStyles" (click)="handleClick()">
  @if(title){
  <s-card-header [title]="title"></s-card-header>
  }
  <div class="card-body">
    @if (html) {
    <div [innerHTML]="html"></div>
    } @else {
    <ng-content></ng-content>
    }
  </div>
  <div class="card-footer">
    <ng-content select="[card-footer]"></ng-content>
  </div>
</div>
